export default __webpack_public_path__ + "static/media/img-3302.1ecc623f.jpeg";